import AddonSocketService from "../addon_socket_service";
import io from "socket.io-client";
import { API_BASE_URL } from "../../../../core/constants/app_constants";

class AddonSocketServiceImpl extends AddonSocketService {
    static #instance = null; // Private static instance
    addonSocket = null;

    constructor() {
        if (AddonSocketServiceImpl.#instance) {
            return AddonSocketServiceImpl.#instance; // Return existing instance
        }
        super();
        AddonSocketServiceImpl.#instance = this; // Store instance
    }

    connect() {
        try {
            if (this.addonSocket) {
                console.log("Addon socket already exists");
                return;
            }
            console.log("AddonSocketServiceImpl connect");
            this.addonSocket = io(`${API_BASE_URL}/payment`, {
                path: '/socket.io'
            });
            this.addonSocket.on('connect', () => {
                console.log('Connected to /addons namespace with id:', this.addonSocket.id);
            });
            this.addonSocket.on('disconnect', () => {
                console.log('Disconnected from /addons namespace');
            });
            
            // Listen for addon purchase updates
            this.addonSocket.on('paymentEvent', (data) => {
                console.log('Addon purchase update:', data);
                // You can dispatch Redux actions here to update the UI
            });
            
            // Listen for addon status changes
            this.addonSocket.on('addon_status_change', (data) => {
                console.log('Addon status change:', data);
                // You can dispatch Redux actions here to update the UI
            });
            
        } catch (error) {
            console.error("AddonSocketServiceImpl connect error:", error);
        }
    }

    disconnect() {
        console.log("AddonSocketServiceImpl disconnect");
        if (this.addonSocket) {
            this.addonSocket.disconnect();
            this.addonSocket = null;
        }
    }

    getSocketId() {
        return this.addonSocket?.id || null;
    }

    // Method to emit addon purchase event
    emitAddonPurchase(addonData) {
        if (this.addonSocket) {
            this.addonSocket.emit('purchase_addon', addonData);
        }
    }

    // Method to emit addon status check
    emitAddonStatusCheck(addonId) {
        if (this.addonSocket) {
            this.addonSocket.emit('check_addon_status', { addonId });
        }
    }
}

export default AddonSocketServiceImpl; 